// ======================================================================
// File Name       : SuperuserEnterpriseRoleRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { superuserEnterpriseRoleEdit } from '../../actions/SuperuserEnterpriseRoleAction';
import FormControlValidate from '../../components/FormControlValidate';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import AboutRoleDialog from '../../components/superuserEnterpriseRole/AboutRoleDialog';
import RoleManagementFunction from '../../components/superuserEnterpriseRole/RoleManagementFunction';
import RoleManagementFunctionDisplay from '../../components/superuserEnterpriseRole/RoleManagementFunctionDisplay';
import RoleRegisterEditConfirm from '../../components/superuserEnterpriseRole/RoleRegisterEditConfirm';
import {
  AUTHORITY_PRESET_DEFAULT,
  MANAGEMENT_AUTHORITY_DISPLAY_TYPE,
  MANAGEMENT_AUTHORITY_TYPE,
  SUPERUSER_ENTERPRISE_AUTHORITY_PRESET_DEFAULT
} from '../../constants/AuthorityConstant';
import * as Path from '../../constants/PathConstants';
import { MODAL_SIZE, MODE } from '../../constants/index';
import HiddenStatusSettingFunctionDisplay from '../../components/superuserEnterpriseRole/HiddenStatusSettingFunctionDisplay';
import { HIDDEN_STATUS } from '../../constants/EnterpriseConstants';

class SuperuserEnterpriseRoleRegisterEditContainer extends React.Component {
  /**
   * The constructor of component
   * @param {*} props
   */
  constructor(props) {
    super(props);
    this.authorityDefault = {
      superuserEnterpriseRoleSecernId: '',
      managementFunctionAuthorityInfo: {
        enterpriseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        serviceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        superuserManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        superuserRoleManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        enterprisePerformanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        enterpriseNoticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
      },
      managementFunctionAuthorityDisplayInfo: {
        enterpriseManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        serviceManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        superuserManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        superuserRoleManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        enterprisePerformanceManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        enterpriseNoticeManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        hiddenStatusSettingDisplay: HIDDEN_STATUS.HIDE_ALL,
      },
    };
    this.state = {
      mode: MODE.NEW_MODE,
      authority: { ...this.authorityDefault },
      defaultChecked: AUTHORITY_PRESET_DEFAULT.DEFAULT,
      showModalConfirm: false,
      showAboutDialog: false,
      isDisabledSettingDisplay: false,
    };
    this.handleAuthorityChange = this.handleAuthorityChange.bind(this);
    this.handleManagementFunctionAuthorityChange = this.handleManagementFunctionAuthorityChange.bind(this);
    this.handleDefaultPresetChange = this.handleDefaultPresetChange.bind(this);
    this.openRegistUpdateConfirmDialog = this.openRegistUpdateConfirmDialog.bind(this);
    this.onRegistUpdateOk = this.onRegistUpdateOk.bind(this);
    this.onRegistUpdateCancel = this.onRegistUpdateCancel.bind(this);
    this.openAuthorityAboutDialog = this.openAuthorityAboutDialog.bind(this);
    this.onAuthorityAboutOk = this.onAuthorityAboutOk.bind(this);
    this.handleManagementFunctionAuthorityDisplayChange =
      this.handleManagementFunctionAuthorityDisplayChange.bind(this);
    this.getManagementFuntionAuthorityDefaultPreset = this.getManagementFuntionAuthorityDefaultPreset.bind(this);
    this.backPage = this.backPage.bind(this);
  }

  /**
   * Life cycle function of component
   */
  componentWillMount() {
    const {
      superuserEnterpriseRole: { authorityInfo },
      match,
      history,
      authed,
    } = this.props;
    const { roleList } = authorityInfo;
    for (const curr of roleList) {
      if (match.params.id && curr.superuserEnterpriseRoleSecernId === match.params.id) {
        this.setState({
          mode: MODE.EDIT_MODE,
          authority: curr,
        });
      }
    }
  }

  /**
   * Life cycle function
   */
  componentWillReceiveProps(nextProps) {
    const { superuserEnterpriseRole, match } = nextProps;
    if (superuserEnterpriseRole) {
      const { roleList } = superuserEnterpriseRole;
      if (!roleList) return;
      for (const curr of roleList) {
        if (match.params.id && curr.superuserEnterpriseRoleSecernId === match.params.id) {
          this.setState({
            mode: MODE.EDIT_MODE,
            authority: curr,
          });
        }
      }
    }
  }

  /**
   * Open dialog regist update confirm dialog
   */
  openRegistUpdateConfirmDialog() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      (ref) => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation()
    );
    if (isValid) {
      this.setState({ showModalConfirm: true });
    }
  }

  /**
   * Event click button ok in confirm dialog
   */
  onRegistUpdateOk() {
    this.setState({
      showModalConfirm: false,
    });
    const { authority, mode } = this.state;
    const param = {
      editType: mode,
      roleInfo: { ...authority },
    };

    const targetAuthority = { ...authority };
    const { managementFunctionAuthorityDisplayInfo, managementFunctionAuthorityInfo } = targetAuthority;
    if (param.roleInfo && param.roleInfo.managementFunctionAuthorityDisplayInfo) {
      // check in 画面表示 is 表示 or 非表示, in case of 非表示, set 0 as default value
      const resultManagementAuthorityInfo = Object.keys(managementFunctionAuthorityDisplayInfo).reduce((acc, cur) => {
        const targetName = cur.replace('Display', '');
        // Step 11.0.0 START
        if (targetName === 'hiddenStatusSetting') {
          acc[targetName] = managementFunctionAuthorityDisplayInfo[cur];
        } else {
          acc[targetName] =
            managementFunctionAuthorityDisplayInfo[cur] > 0 ? managementFunctionAuthorityInfo[targetName] : 0;
        }
        // Step 11.0.0 END
        return acc;
      }, {});
      param.roleInfo.enterpriseManagementFunctionAuthorityInfo = resultManagementAuthorityInfo;

      // delete in param to make sure not send in request
      delete param.roleInfo.managementFunctionAuthorityInfo;
      delete param.roleInfo.managementFunctionAuthorityDisplayInfo;
      delete param.roleInfo.enterpriseManagementAuthority;
    }
    const { history } = this.props;
    this.props.dispatch(superuserEnterpriseRoleEdit(param)).then(() => {
      //  Back to superuser enterprise role list
      history.push(Path.SUPERUSER_ENTERPRISE_ROLE_LIST);
    });
  }

  /**
   * Event click button cancel in confirm dialog
   */
  onRegistUpdateCancel() {
    this.setState({
      showModalConfirm: false,
    });
  }

  getManagementFuntionAuthorityDefaultPreset(value) {
    let managementFunctionAuthorityInfo = '';
    switch (value) {
      case SUPERUSER_ENTERPRISE_AUTHORITY_PRESET_DEFAULT.DEFAULT:
        managementFunctionAuthorityInfo = {
          enterpriseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          serviceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          superuserManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          superuserRoleManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          enterprisePerformanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          enterpriseNoticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          hiddenStatusSetting: HIDDEN_STATUS.HIDE_ALL,
        };
        break;
      case SUPERUSER_ENTERPRISE_AUTHORITY_PRESET_DEFAULT.ADMIN:
        managementFunctionAuthorityInfo = {
          enterpriseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          serviceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          superuserManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          superuserRoleManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          enterprisePerformanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          enterpriseNoticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          hiddenStatusSetting: HIDDEN_STATUS.SHOW_ALL,
        };
        break;
      case SUPERUSER_ENTERPRISE_AUTHORITY_PRESET_DEFAULT.READ_ONLY_ADMIN:
        managementFunctionAuthorityInfo = {
          enterpriseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          serviceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          superuserManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          superuserRoleManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          enterprisePerformanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          enterpriseNoticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          hiddenStatusSetting: HIDDEN_STATUS.SHOW_ALL,
        };
        break;
      default:
        break;
    }
    return managementFunctionAuthorityInfo;
  }

  /**
   * Event select radio button preset default
   * @param {*} event
   */
  handleDefaultPresetChange(event) {
    const value = parseInt(event.target.value, 10);
    const authority = { ...this.state.authority };

    authority.managementFunctionAuthorityInfo = this.getManagementFuntionAuthorityDefaultPreset(value);
    const authorityDisplayMapping = Object.keys(authority.managementFunctionAuthorityInfo).reduce((acc, cur) => {
      // Step 11.0.0 START
      if (cur === 'hiddenStatusSetting') {
        acc[`${cur}Display`] = authority.managementFunctionAuthorityInfo[cur];
      } else {
        acc[`${cur}Display`] = authority.managementFunctionAuthorityInfo[cur] > 0
          ? MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
          : MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
      }
      // Step 11.0.0 END
      return acc;
    }, {});

    authority.managementFunctionAuthorityDisplayInfo = {
      ...authorityDisplayMapping,
    };

    this.setState({
      authority,
      defaultChecked: value,
    });
  }

  /**
   * Handle change authority name
   * @param {*} event
   */
  handleAuthorityChange(event) {
    const { name, value } = event.target;
    const { authority } = this.state;
    authority[name] = value;
    this.setState({ authority });
  }

  /**
   * Handle change radio button function authority
   * @param {*} event
   */
  handleManagementFunctionAuthorityChange(event) {
    const { name, value } = event.target;
    const { authority } = this.state;
    authority.managementFunctionAuthorityInfo[name] = parseInt(value, 10);
    this.setState({ authority });
  }

  handleManagementFunctionAuthorityDisplayChange(event) {
    const { name, value } = event.target;
    const { authority } = this.state;
    const targetValue = parseInt(value, 10);
    authority.managementFunctionAuthorityDisplayInfo[name] = targetValue;

    // set selected value if user change 非表示 to 表示
    // Step 11.0.0 START
    if (name !== 'hiddenStatusSettingDisplay' && targetValue === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY) {
    // Step 11.0.0 END
      const targetAuthorityPermission = name.replace('Display', '');
      let authorityTargetValue = '';
      if (
        targetAuthorityPermission === 'enterprisePerformanceManagementAuthority'
      ) {
        authorityTargetValue = MANAGEMENT_AUTHORITY_TYPE.REFERENCE;
      } else {
        authorityTargetValue = MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT;
      }
      authority.managementFunctionAuthorityInfo[targetAuthorityPermission] = authorityTargetValue;
    }
    this.setState({ authority });
  }

  /**
   * Show more information when click
   */
  openAuthorityAboutDialog() {
    this.setState({ showAboutDialog: true });
  }

  onAuthorityAboutOk() {
    this.setState({ showAboutDialog: false });
  }

  backPage() {
    this.props.history.goBack();
  }

  /**
   * Render function of component
   */
  render() {
    const isNewMode = this.state.mode === MODE.NEW_MODE;
    const { isDisabledSettingDisplay } = this.state;
    const {
      superuserEnterpriseRoleSecernId,
      superuserEnterpriseRoleName,
      managementFunctionAuthorityInfo,
      managementFunctionAuthorityDisplayInfo,
    } = this.state.authority;
    this.refsToValidate = [];
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.SUPERUSER_ENTERPRISE_ROLE_LIST}
          text="企業ロール一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={isNewMode ? '企業ロールの追加' : `企業ロールの編集 - ${superuserEnterpriseRoleName}`} />
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.openRegistUpdateConfirmDialog();
          }}
          className='form-horizontal'
          style={{ display: 'flow-root' }}
        >
          <Form.Group className="margin-top-10">
            <Col sm={7}>
              <h4>{isNewMode ? '登録する項目を指定してください' : '編集する項目を指定してください'}</h4>
            </Col>
            <Col sm={5}>
              <a className="link" onClick={this.openAuthorityAboutDialog}>
                <u className="cursor_pointer">各管理画面の権限ロールについて</u>
              </a>
            </Col>
            <Col sm={12} as={Form.Label} className="margin-top-10 ps-0">
              <h4>プリセットを元に編集することも可能です。</h4>
            </Col>
          </Form.Group>
          <Col className="padding-right-15">
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                プリセット
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="なし"
                  id="super-enterprise-authority-default-0"
                  value={0}
                  checked={this.state.defaultChecked === SUPERUSER_ENTERPRISE_AUTHORITY_PRESET_DEFAULT.DEFAULT}
                  onChange={this.handleDefaultPresetChange}
                  label='なし'></Form.Check>
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="全権限"
                  id="super-enterprise-authority-default-1"
                  value={1}
                  checked={this.state.defaultChecked === SUPERUSER_ENTERPRISE_AUTHORITY_PRESET_DEFAULT.ADMIN}
                  onChange={this.handleDefaultPresetChange}
                  label='全権限'></Form.Check>
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="読み取り専用"
                  id="super-enterprise-authority-default-2"
                  value={2}
                  checked={this.state.defaultChecked === SUPERUSER_ENTERPRISE_AUTHORITY_PRESET_DEFAULT.READ_ONLY_ADMIN}
                  onChange={this.handleDefaultPresetChange}
                  label='読み取り専用'></Form.Check>
              </Col>
            </Form.Group>

            <hr className="break-line margin-top-10 margin-left-right-15" />
            <hr className="break-line margin-bottom-10 margin-left-right-15" />

            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                企業ロール名<span className="required">&nbsp;(※)</span>
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  label="企業ロール名"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                  name="superuserEnterpriseRoleName"
                  value={superuserEnterpriseRoleName}
                  onChange={this.handleAuthorityChange}
                  type="text"
                  maxLength="64"
                />
              </Col>
            </Form.Group>

            <Form.Group>
              <Col sm={12} className="padding-left-15 padding-bottom-10">
                <p>画面表示</p>
              </Col>
              <Col sm={12} className="padding-left-50">
                <Form.Group>
                  <Col sm={12}>
                    <RoleManagementFunctionDisplay
                      label="企業管理"
                      name="enterpriseManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.enterpriseManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="サービス管理"
                      name="serviceManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.serviceManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="管理ユーザー"
                      name="superuserManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.superuserManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="ロールと権限"
                      name="superuserRoleManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.superuserRoleManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="企業システム利用実績"
                      name="enterprisePerformanceManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.enterprisePerformanceManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="企業向けお知らせ一覧"
                      name="enterpriseNoticeManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.enterpriseNoticeManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    {/* Step 11.0.0 START */}
                    <HiddenStatusSettingFunctionDisplay
                      label="問い合わせ・マニュアル表示"
                      name="hiddenStatusSettingDisplay"
                      value={managementFunctionAuthorityDisplayInfo.hiddenStatusSettingDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    {/* Step 11.0.0 END */}
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
            <Form.Group>
              <Col sm={12} className="padding-left-15 padding-bottom-10 margin-top-20">
                <p>権限設定</p>
              </Col>
              <Col sm={12} className="padding-left-50">
                <Form.Group>
                  <Col sm={12}>
                    <RoleManagementFunction
                      label="企業管理"
                      name="enterpriseManagementAuthority"
                      value={managementFunctionAuthorityInfo.enterpriseManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.enterpriseManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="サービス管理"
                      name="serviceManagementAuthority"
                      value={managementFunctionAuthorityInfo.serviceManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.serviceManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="管理ユーザー"
                      name="superuserManagementAuthority"
                      value={managementFunctionAuthorityInfo.superuserManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.superuserManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="ロールと権限"
                      name="superuserRoleManagementAuthority"
                      value={managementFunctionAuthorityInfo.superuserRoleManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.superuserRoleManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="企業システム利用実績"
                      name="enterprisePerformanceManagementAuthority"
                      value={managementFunctionAuthorityInfo.enterprisePerformanceManagementAuthority}
                      notRegisterEdit
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.enterprisePerformanceManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="企業向けお知らせ一覧"
                      name="enterpriseNoticeManagementAuthority"
                      value={managementFunctionAuthorityInfo.enterpriseNoticeManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.enterpriseNoticeManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
            <Form.Group className="margin-top-50 text-center">
              <Col sm={12} className="text-center margin-top-50">
                {!isNewMode && (
                  <Button variant="default" className="btn btn-default btn-96" role="button" onClick={this.backPage.bind(this)}>
                    キャンセル
                  </Button>
                )}
                <Button variant="primary" className="margin-left-10 margin-left-10 btn-96" type="submit">
                  OK
                </Button>
              </Col>
            </Form.Group>
          </Col>
        </Form>
        <RoleRegisterEditConfirm
          showModal={this.state.showModalConfirm}
          size={MODAL_SIZE.lg}
          authority={this.state.authority}
          onRegisterEditOk={this.onRegistUpdateOk}
          onRegisterEditCancel={this.onRegistUpdateCancel}
        />
        <AboutRoleDialog showModal={this.state.showAboutDialog} onAuthorityAboutOk={this.onAuthorityAboutOk} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ superuserEnterpriseRole: state.superuserEnterpriseRole, authed: state.authed },
});

export default connect(mapStateToProps)(SuperuserEnterpriseRoleRegisterEditContainer);
